import { hideLogoutInterstitial, showLogoutInterstitial } from "./auth-ui";

const doMultipass = (res) => {
  let data = {
    id: res.UID,
    email: res.profile.email,
    firstName: res.profile.firstName,
    lastName: res.profile.lastName,
    returnMultipassToken: true,
  };

  const url = window.location.href;
  const urlObj = new URL(url);
  const returnUrl = urlObj.searchParams.get("return_url");
  if (returnUrl && urlObj.hash) window.loginReturnTo = returnUrl + urlObj.hash;
  if (window.loginReturnTo) data.returnTo = window.loginReturnTo;

  fetch(window.akc.services.multipassUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => {
      window.localStorage.setItem("multipassToken", data.token);
      window.localStorage.removeItem("customerAccessToken");
      window.localStorage.removeItem("customerAccessTokenExpiresAt");
      window.location.href = data.authUrl;
    })
    .catch((err) => console.error(err));
};

const initRecaptcha = (action, callback = null) => {
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(window.akc.recaptcha.siteKey, { action })
        .then((token) => {
          if (callback) {
            callback(token)
              .then((result) => {
                resolve(result);
              })
              .catch((error) => {
                reject(error);
              });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  });
};

const verify = async (token) => {
  const response = await fetch(window.akc.services.recaptchaUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
  });
  const data = await response.json();
  return data.siteVerifyResponse.score <= window.akc.recaptcha.threshold;
};

const checkBot = async (event) => {
  const action =
    event.form === "gigya-register-form" ? "sign_up" :
    event.form === "gigya-login-form"    ? "sign_in" : undefined;

  const isBot = await initRecaptcha(action, verify);

  const errors = {
    sign_in: { form: "Bot detected: prevent sign in" },
    sign_up: { form: "Bot detected: prevent sign up" },
  };
  if (isBot) return errors[action];
};

gigya.accounts.addEventHandlers({
  onLogin: doMultipass,
  onLogout: () => {
    window.localStorage.removeItem("multipassToken");
    window.localStorage.removeItem("customerAccessToken");
    window.localStorage.removeItem("customerAccessTokenExpiresAt");
    window.location.href = window.akc.routes.accountLogoutUrl;
  },
});

// Global session validator - runs on all pages
// session.verify is recommended over getAccountInfo for login checks (lighter weight)
const validateGlobalSession = () => {
  gigya.accounts.session.verify({
    callback: (res) => {
      if (res.errorCode !== 0 && window.localStorage.getItem("multipassToken")) {
        console.warn("Gigya session expired, forcing logout...");
        window.akc.getLogoutScreenset();
      }
    },
  });
};

// Check every 5 minutes if user is still logged in
setInterval(validateGlobalSession, 5 * 60 * 1000);

// Also validate on page visibility change (when tab returns to focus)
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") {
    validateGlobalSession();
  }
});

window.akc.getRegisterScreenset = (options) => {
  window.loginReturnTo = options?.returnTo || window.location.href;

  window.gigya.accounts.showScreenSet({
    screenSet: "Login-web-2",
    startScreen: "gigya-register-screen",
    mobileScreenSet: "Login-web-2",
    onBeforeValidation: (e) => checkBot(e),
  });
};

window.akc.getLoginScreenset = (options) => {
  window.loginReturnTo = options?.returnTo || window.location.href;
  if (window.location.pathname === window.akc.routes.cartUrl) {
    window.loginReturnTo = window.akc.routes.cartUrl;
  }

  window.gigya.accounts.showScreenSet({
    screenSet: "Login-web-2",
    startScreen: "gigya-login-screen",
    mobileScreenSet: "Login-web-2",
    onBeforeValidation: (e) => checkBot(e),
  });
};

window.akc.getLogoutScreenset = () => {
  window.localStorage.removeItem("multipassToken");
  window.localStorage.removeItem("customerAccessToken");
  window.localStorage.removeItem("customerAccessTokenExpiresAt");

  let currentPageURL = window.location.href;
  let redirectToCurrentPage = (response) => {
    window.localStorage.setItem("logoutResponse", JSON.stringify(response));
    showLogoutInterstitial();
    if (response.errorCode == 0) {
      setTimeout(() => {
        window.location.href = currentPageURL;
        hideLogoutInterstitial();
      }, 1000); // 1000ms delay prevent redirect before logout fully completes
    } else {
      alert("Error :" + response.errorMessage);
    }
  };

  window.gigya.accounts.logout({ callback: redirectToCurrentPage });
};
